import MainLayout from '../../../shared/Layouts/MainLayout'
import css from './maintenance.module.css'
import NavigationBreadcrumbs from '../../../navigation/components/NavigationBreadcrumbs'
import Tabs from '../../../shared/Tabs'
import maintenancePageConstants from './maintenancePage.constants.ts'
import { useState } from 'react'
import { TMaintenanceCardTab } from './maintenance.types.ts'
import MaintenanceBlanks from './MaintenanceBlanks'
import MaintenanceProcesses from './MaintenanceProcesses'
import useTitle from '@/shared/hooks/useTitle'

const MaintenancePage = () => {
  useTitle('Техническое обслуживание')
  const [selectedTab, setSelectedTab] = useState<TMaintenanceCardTab>('processes')

  const renderContent = () => {
    switch (selectedTab) {
      case 'blanks':
        return <MaintenanceBlanks />
      case 'processes':
        return <MaintenanceProcesses />
    }
  }

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className="flex-lines gap16 height100">
          <NavigationBreadcrumbs />
          <div className="flex-lines gap4">
            <h2 className="text-heading-3">Техническое обслуживание</h2>
          </div>
          <div className={css.mainCard} data-selected-tab={selectedTab}>
            <div>
              <Tabs
                tabs={maintenancePageConstants.cardTabs}
                onSelect={setSelectedTab as any}
                selectedTab={selectedTab}
              />
            </div>
            {renderContent()}
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default MaintenancePage
